import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';
import { AddPatientToGroupModalModule } from 'src/app/ui/dashboard/routes/questions/routes/patients-list/components/add-patient-to-group-modal/add-patient-to-group-modal.module';

import { CoreModule } from '../../../../core/core.module';
import { AvatarModule } from '../../../components/avatar/avatar.module';
import { NextAppointmentCellModule } from '../../../components/next-appointment-cell/next-appointment-cell.module';
import { PersonalInformationRoundedCellModule } from '../../../components/personal-information-rounded-cell/personal-information-rounded-cell.module';
import { WeightAndSizeModalModule } from '../../../components/weight-and-size-modal/weight-and-size-modal.module';
import { EditPatientModalModule } from './components/edit-patient-modal/edit-patient-modal.module';
import { InvitationTemplateModalModule } from './components/invitation-template-modal/invitation-template-modal.module';
import { NextAppointmentModalModule } from './components/next-appointment-modal/next-appointment-modal.module';
import { PersonalInformationCellComponent } from './components/personal-information-cell/personal-information-cell.component';
import { PatientInfoSidebarComponent } from './patient-info-sidebar.component';

@NgModule({
  declarations: [PatientInfoSidebarComponent, PersonalInformationCellComponent],
  exports: [PatientInfoSidebarComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    AvatarModule,
    ReactiveFormsModule,
    FormsModule,
    NextAppointmentModalModule,
    NextAppointmentCellModule,
    PersonalInformationRoundedCellModule,
    TooltipModule,
    NgxInnerLoadingModule,
    EditPatientModalModule,
    AddPatientToGroupModalModule,
    InvitationTemplateModalModule,
    WeightAndSizeModalModule,
    CoreModule,
  ],
})
export class PatientInfoSidebarModule {}
